<div class="  ">
    <section class="my-4">
        <div class="scrollmenu">



            <a [routerLink]="['/pos/businessinfo']"> Business-info </a>
            <a [routerLink]="['/pos/customer/manage']"> Customer </a>
            <a [routerLink]="['/pos/employee/manage']"> Employee </a>
            <a [routerLink]="['/pos/orders/manage']"> Orders </a>
            <a [routerLink]="['/pos/taxfee/manage']"> Tax-Fee </a>
            <a [routerLink]="['/pos/category/manage']"> Item-Category </a>
            <a [routerLink]="['/pos/item/manage']">Items </a>
            <a [routerLink]="['/pos/businesshour/manage']"> Business-Hours </a>

            <!-- <a [routerLink]="['/pos/businessinfo']"> Business-info </a>
            <a [routerLink]="['/pos/customer/new']"> Customer </a>
            <a [routerLink]="['/pos/Employee/new']"> Employee </a>
            <a [routerLink]="['/pos/orders/new']"> Orders</a>
            <a [routerLink]="['/pos/businesshour/new']"> Business-Hours </a>
            <a [routerLink]="['/pos/item/new']"> Items </a>
            <a [routerLink]="['/pos/category/new']"> Item-Category </a>
            <a [routerLink]="['/pos/order/new']"> Order </a>
            <a [routerLink]="['/pos/orderreceipt/new']"> Order Receipt </a>
            <a [routerLink]="['/pos/payment/new']"> Payment </a>
            <a [routerLink]="['/pos/paymentrecipt/new']"> Payment Receipt </a>
            <a [routerLink]="['/pos/taxfee/new']"> Tax Fee </a>
            <a [routerLink]="['/pos/tip/new']"> Tips </a> -->

            <!--  <a [routerLink]="['/pos/orderregister']"> Order Register </a>  -->
            <!--  <a [routerLink]="['/pos/ordertype/new']"> Order Type </a> -->
            <!--   <a [routerLink]="['/pos/tender/new']">  Tender </a>  -->
        </div>
    </section>
    <div class="row">
        <div class="col-sm-8">
            <div class="pos_dashboard mb-3">
                <div class="row">
                    <div class="col-md-3">
                        <div class="pos_div" id="SaveEmployee" [routerLink]="['/pos/orders/new']">
                            <div class="pos_layout_div">
                                <!-- <div class="img_section">
                                    <img src="assets/img/new/sales-icon.png" width="50px" />
                                </div> -->
                                <img src="assets/img/new/sales-icon.png" width="50px" />
                                <h5>Sales</h5>
                            </div>
                            <div class="pos_layout_link">
                                <a [routerLink]="['/pos/orders/new']">View More <i class="fa fa-arrow-right"
                                        aria-hidden="true"></i></a>
                            </div>
                        </div>

                    </div>
                    <div class="col-md-3">
                        <div class="pos_div" id="SaveEmployee">
                            <div class="pos_layout_div">
                                <!-- <div class="img_section">
                                    <img src="assets/img/new/sales-icon.png" width="50px" />
                                </div> -->
                                <img src="assets/img/new/reports-icon.png" width="50px" />
                                <h5>Reports</h5>
                            </div>
                            <div class="pos_layout_link">
                                <a [routerLink]="['/pos/orders/new']">View More <i class="fa fa-arrow-right"
                                        aria-hidden="true"></i></a>
                            </div>
                        </div>

                    </div>
                    <div class="col-md-3">
                        <div class="pos_div" id="SaveEmployee" [routerLink]="['/pos/orders/new']">
                            <div class="pos_layout_div">
                                <!-- <div class="img_section">
                                    <img src="assets/img/new/sales-icon.png" width="50px" />
                                </div> -->
                                <img src="assets/img/new/orders.png" width="50px" />
                                <h5>Orders</h5>
                            </div>
                            <div class="pos_layout_link">
                                <a [routerLink]="['/pos/orders/new']">View More <i class="fa fa-arrow-right"
                                        aria-hidden="true"></i></a>
                            </div>
                        </div>

                    </div>
                    <div class="col-md-3">
                        <div class="pos_div" id="SaveEmployee" [routerLink]="['/pos/item/new']">
                            <div class="pos_layout_div">
                                <!-- <div class="img_section">
                                    <img src="assets/img/new/sales-icon.png" width="50px" />
                                </div> -->
                                <img src="assets/img/new/setup-icon.png" width="50px" />
                                <h5>SetUp</h5>
                            </div>
                            <div class="pos_layout_link">
                                <a [routerLink]="['/pos/item/new']">View More <i class="fa fa-arrow-right"
                                        aria-hidden="true"></i></a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4">

        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="tabsection">
                <ul>
                    <li><a (click)="pendingOrderList()" [ngClass]="{'active6': activetab==='tab11'}">Pending Order
                            List</a></li>
                    <li><a (click)="completedOrderList()" [ngClass]="{'active6': activetab==='tab12'}">Completed Order
                            List</a></li>

                </ul>

            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="row pos-card" *ngIf="pospendingOrdersList">
                <div class="col-md-12 p-0">
                    <h4 class="font22  pb-3 mb-0  black-l-t font-weight-bold">Pending Order List</h4>
                    <div>
                        <ngx-datatable #myTable class='bootstrap no-detail-row' [scrollbarH]="true" [headerHeight]="40"
                            [footerHeight]="38" [rowHeight]="40" [limit]="10" [rows]="pendingorders">


                            <ngx-datatable-column name="Action">




                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <a class="view" (click)="copyurl(row.url)" data-toggle="tooltip"
                                        data-placement="top" title="copy">
                                        <i class="fas mr-3 fa-copy"></i>
                                    </a>
                                    <a class="view"
                                        [routerLink]="['/pos/orderdetails/view',{id : row.Id,orderid: row.orderId}]"
                                        data-toggle="tooltip" data-placement="top" title="View">
                                        <img src="./assets/ViewDetails.svg">
                                    </a>

                                    <a class="edit px-2"
                                        [routerLink]="['/pos/orders/new',{id : row.Id,orderid: row.orderId}]"
                                        data-toggle="tooltip" data-placement="top" title="Edit">
                                        <em class="fa-1x mr-2 fas fa-edit"></em>
                                    </a>

                                </ng-template>
                            </ngx-datatable-column>
                            <!-- <ngx-datatable-column name="Order Id" >
                            <ng-template let-row="row" ngx-datatable-cell-template> {{row.url}}
                            </ng-template>
                        </ngx-datatable-column> -->
                            <ngx-datatable-column name="Order Id">
                                <ng-template let-row="row" ngx-datatable-cell-template> {{row.orderId}}
                                </ng-template>
                            </ngx-datatable-column>

                            <ngx-datatable-column name="Item Count">
                                <ng-template let-row="row" ngx-datatable-cell-template> {{row.lineItemCount}}
                                </ng-template>

                            </ngx-datatable-column>
                            <ngx-datatable-column name="Amount">

                                <ng-template let-row="row" ngx-datatable-cell-template><span class="robot">
                                        {{currency}}{{row.totalNetAmount}}</span>
                                </ng-template>
                            </ngx-datatable-column>

                            <ngx-datatable-column name="Date">
                                <ng-template let-row="row" ngx-datatable-cell-template> {{row.dateTime | date:'d/M/yy,
                                    h:mm a'}}
                                </ng-template>

                            </ngx-datatable-column>
                        </ngx-datatable>

                    </div>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-12"> -->
            <div class="pos-card" *ngIf="poscompletedOrdersList">
                <h4 class="font22 pb-3 mb-0  black-l-t font-weight-bold">Completed Order List</h4>
                <div>
                    <ngx-datatable #myTable class='bootstrap no-detail-row' [scrollbarH]="true" [headerHeight]="40"
                        [footerHeight]="38" [rowHeight]="40" [limit]="10" [rows]="completeorders">

                        <ngx-datatable-column name="Action">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <a class="edit"
                                    [routerLink]="['/pos/orderdetails/view',{id :row.Id,orderid: row.OrderId}]"
                                    data-toggle="tooltip" data-placement="top" title="View">
                                    <img src="./assets/ViewDetails.svg">
                                </a>

                            </ng-template>
                        </ngx-datatable-column>



                        <ngx-datatable-column name="Order ID">
                            <ng-template let-row="row" ngx-datatable-cell-template> {{row.OrderId}}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Item Count">
                            <ng-template let-row="row" ngx-datatable-cell-template> {{row.LineItemCount}}
                            </ng-template>

                        </ngx-datatable-column>
                        <ngx-datatable-column name="Amount">

                            <ng-template let-row="row" ngx-datatable-cell-template>
                                {{currency}}{{row.LineItemTotalAmount}}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Date">
                            <ng-template let-row="row" ngx-datatable-cell-template> {{row.DateTime | date:'d/M/yy, h:mm
                                a'}}
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- <ngx-datatable-column name="Item Description" >
                <ng-template let-row="row" ngx-datatable-cell-template> {{row.itemDescription}} </ng-template>
                
                </ngx-datatable-column> -->
                    </ngx-datatable>

                </div>
            </div>
        </div>



        <div class="row  ">

            <!-- <div class="col-md-6 p-0 align-self-top">
            <div >
                <div class="  text-center">
                    <button type="button"class="btn btn-block pos-hme-btn"  id="SaveEmployee" style="font-size: 36px;"><img class="mr-2" src="assets/img/pos-terminal.png">Clock In/ Out</button>

                </div>
            </div>
        </div> -->

        </div>
    </div>